export const apiUrl = process.env.REACT_APP_API_URL;

export const endpoints = {
  login: "loginClient",
  signup: "addClient",
  properties: "addProperty",
  meters: "addData",
  meterWeeklyConsumption: "barGraph_dshb",
  meterDailyConsumption: "lineGraph_dshb",
  propertiesForDashboard: "getProperty_forDashboard",
  allClients: "allClients",
  addClient: "addClient",
  addMeter: "addMeter",
  payloadDetails: "Payload_Detail",
  dailyCutoffs: "moredata",
  monthlyCutoffs: "monthlycutoffs",
  meterDetails: "meterDetails",
  // Shared URL endpoints
  sharedUrl: "shared-url",
  sharedView: "shared",
  // Billing
  billing: "billing",
  billingPublicMeter: "billing/public/meter",
  // Report download logging
  reportDownloadLog: "report-downloads/log",
  // Public meter info (label/house number)
  meterPublicInfo: "meter/public-info",
  // Public meter device info (provider-routed by meter model)
  meterDeviceInfo: "meter/device-info",
  // M-Pesa STK push
  stkPush: "billing/stk-push",
};

export const DEFAULT_PAGE_LIMIT = 10;
